// import { DataTransRequest } from './DataTransReqest';
import { COLUMNS } from './Column';
import { DefaultTable } from '../Components/DefaultTable';

import { useEffect, useState } from 'react';
import axios from 'axios';
// import FitButtons from '../Components/FitButton';
import { MdAccountCircle } from 'react-icons/md';
import { LiaStarSolid } from 'react-icons/lia';
import {
  formatAmount,
  formatDateStrToDate,
  formatRating,
  getToken,
} from '../utils';
import { LoadingMode } from '../Components/LoadingMode';
import { BuyandSellOfferTableModals } from '../TradeCurrency/BuyandSellOfferTableModals';
import OpenandCloseModal from '../TradeCurrency/OpenandCloseModal';

const RequestTable = (props) => {
  const {
    handleOpenandCloseModal,
    setOfferDetails,
    offerDetails,
    setCxId,
    cxId,
    openModal,
  } = OpenandCloseModal();

  const [isLoading, setIsLoading] = useState(false);
  // const [isSubmiting, setisSubmiting] = useState(false);
  const [pendingTransactionData, setPendingTransactionData] = useState([]);
  const [getDataById, setGetDataById] = useState({});

  const userToken = getToken()?.token;

  // console.log({ pendingTransactionData, getDataById });

  useEffect(() => {
    setIsLoading(true);
    const getBuyOffers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/cx-transaction/my-ongoing-transactions`,

          { headers: { Authorization: `Bearer ${userToken}` } }
        );

        setPendingTransactionData(response?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getBuyOffers();
  }, [userToken]);

  const handleGetId = (dataId) => {
    const findDatabyId = pendingTransactionData.find((data) => {
      return data.id === dataId;
    });

    setGetDataById(findDatabyId);
    handleOpenandCloseModal('offerdetails');
  };

  const PendingTableDatas = pendingTransactionData?.map((data) => ({
    date: `${formatDateStrToDate(data.created_at)}`,
    currency: (
      <div className='flex flex-row items-center gap-2 justify-center'>
        <img
          src={data?.quote_currency?.country?.flag}
          alt='currency flag'
          className='w-5 h-[13px]'
        />
        <p>{data?.quote_currency?.symbol}</p>
      </div>
    ),
    amount: (
      <div className='flex flex-row items-center gap-2 justify-center'>
        <img
          src={data?.quote_currency?.country?.flag}
          alt='currency flag'
          className='w-5 h-[13px]'
        />
        <p>
          {`${formatAmount(data?.amount * 1)}
            ${data?.quote_currency?.symbol}`}
        </p>
      </div>
    ),
    rate: `${formatAmount(data?.rate)} ${data?.base_currency.symbol}`,
    total: `${formatAmount(data?.amount * data?.rate)} ${
      data?.base_currency?.symbol
    }`,
    status: data?.transaction_status?.name,
    buyer_seller: (
      <div className='flex flex-row items-start gap-2'>
        <span className='text-4xl text-b-mc/70'>
          <MdAccountCircle />
        </span>
        <div className='flex flex-col justify-start text-left'>
          <p>{data?.unique_code}</p>
          <div className='flex flex-col gap- text-sm'>
            <p className='flex flex-row items-center gap-1 text-s-bk'>
              Rating: {formatRating(data?.user?.rating)}{' '}
              <span className='text-green-500 -m-1'>
                <LiaStarSolid />
              </span>
            </p>{' '}
            {/* <p className="flex flex-row items-center gap-1 text-s-bk">
              Order: {data?.user.trx_stats?.completed}{" "}
              <span className="text-green-500 -m-1">{<BiTransfer />}</span>
            </p> */}
          </div>
        </div>
      </div>
    ),
    action: (
      <button
        className='text-p-wh px-6 py-2 rounded-md text-[10px] w-fit active:bg-t-bk hover:bg-orange-600 bg-orange-500'
        onClick={() => handleGetId(data.id)}
      >
        View Offer
      </button>
    ),
  }));

  return (
    <div className='overflow-x-auto'>
      {!!PendingTableDatas?.length && !isLoading && (
        <DefaultTable columns={COLUMNS} data={PendingTableDatas} />
      )}

      <BuyandSellOfferTableModals
        openModal={openModal}
        handleOpenandCloseModal={handleOpenandCloseModal}
        offerDetails={getDataById}
        cxId={getDataById.id}
      />
    </div>
  );
};
export default RequestTable;
